export default __webpack_public_path__ + "1570e8a1afdb084976b8c25d391e0697.svg";